import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { formatCompactTime } from '@/lib/time';
import type { PullRequestItem } from '@/types/pull-request-item';

interface Props {
  pullRequestItems?: PullRequestItem[];
}

export default function Index({ pullRequestItems = [] }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title="Reviews" showNew={false} />
      <div className="ln-page-scroll">
        {pullRequestItems.length === 0 ? (
          <EmptyState
            title="No reviews"
            description="Pull request reviews assigned to you will show here."
          />
        ) : (
          pullRequestItems.map((item) => (
            <a
              key={item.id}
              href={item.githubUrl ?? '#'}
              className="ln-row"
              style={{ height: 52 }}
              target="_blank"
              rel="noreferrer"
            >
              <span className="ln-row-id">
                {item.repoFullName}#{item.number}
              </span>
              <span className="ln-row-title">{item.title}</span>
              <span className="ln-row-meta">
                <span className="ln-label">{item.githubState}</span>
                <span className="ln-row-date">{formatCompactTime(item.createdAt)}</span>
              </span>
            </a>
          ))
        )}
      </div>
    </div>
  );
}
